/**
 * Hub checks and welcome modals scripts
 */
;(function($) {

	/**
	 * Actually closes dialog and stores the dialog close choice
	 */
	function close_dialog() {
		return $.post(ajaxurl, {
			action: 'shipper_modal_closed',
			target: 'welcome',
			_wpnonce: $('.sui-modal.shipper-welcome').attr('data-wpnonce')
		}).always(function() {
			SUI.closeModal();
		});
	}

	/**
	 * Handles dialog closing button click
	 *
	 * @param {Object} e Event object
	 */
	function handle_close_dialog( e ) {
		if (e && e.preventDefault) e.preventDefault();

		close_dialog();

		return false;
	}

	/**
	 * Handles skip link click
	 *
	 * @param {Object} e Event object
	 */
	function handle_skip_click( e ) {
		if (e && e.preventDefault) e.preventDefault();

		window.location.reload();

		return false;
	}


	function open_modal( replace_modal ) {
		var replace_modal = replace_modal ? true : false;
		var modal_id = get_modal_id();
		var focus_after_closed = this;
		var focus_when_open = undefined;
		var has_overlay_mask = false;
		var modal = get_modal();

		SUI[ replace_modal ? 'replaceModal' : 'openModal' ]( modal_id, focus_after_closed, focus_when_open, has_overlay_mask )

		return modal;
	}

	function get_modal_id() {
		return 'shipper-welcome';
	}

	function get_modal() {
		return $( '#' + get_modal_id() );
	}

	function boot_welcome_dialogs() {
		open_modal();

		$('.shipper-welcome-continue').on('click', handle_close_dialog);
		$('.shipper-welcome a[href="#skip"]').on('click', handle_skip_click);
	}

	$(function() {
		if ( get_modal().length ) {
			$(window).on('load', boot_welcome_dialogs);
		}
	});
})(jQuery);
